import React from "react";
import { useLocation } from "react-router-dom";
import { normalizeLang } from "../i18n";
import { getSystemStrings } from "../strings/systemStrings";
import { useAuth } from "../auth/AuthContext";
import LegalFooterLinks from "../components/LegalFooterLinks";
import { SUPPORT_EMAIL } from "../legal/legalContent";
import "./AboutJourneys.css";

function useLang() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return normalizeLang(
    params.get("lang") ||
      (typeof window !== "undefined" ? window.localStorage.getItem("innervoice_lang") : "he")
  );
}

export default function AboutJourneys() {
  const { user } = useAuth();
  const lang = useLang();
  const copy = getSystemStrings(lang, user?.gender).about;

  return (
    <div className="about-page" dir={lang === "he" ? "rtl" : "ltr"}>
      <div className="about-card">
        <h1>{copy.title}</h1>
        {copy.body.map((line, idx) => (
          <p key={`about-${idx}`}>{line}</p>
        ))}
        <p className="about-legal-support">
          <a href={`mailto:${SUPPORT_EMAIL}`}>
            {lang === "he" ? "תמיכה:" : lang === "es" ? "Soporte:" : "Support:"} {SUPPORT_EMAIL}
          </a>
        </p>
        <LegalFooterLinks />
      </div>
    </div>
  );
}
